<template>
<div style="background: #fff;">

	<div class="success" v-if="!complete && loadingButton">
		<div style="height: 25px; width: 25px; margin: auto; margin-bottom: 14px;">
			<LoadSpinnerIcon type="primary"></LoadSpinnerIcon>
		</div>
		<h3 style="font-size: 18px; font-weight: 600; color: #2d3e4f;">
			Importing patients and events
		</h3>
		<h4 style="font-size: 16px; font-weight: 500; color: #999; padding-top: 7px">
			This might take a while…
		</h4>
	</div>

	<div v-else-if="!complete" style="padding: 17px 15px;">

		<h4 style="font-size:18px">Total patients - {{ patient.length }}</h4>
		<div style="padding: 11px 39px 39px 0">
			<el-row :gutter="20">
				<el-col :span="7">
					<el-row type="flex" align="middle" justify="space-around" class="grid-content">
						<el-col :span="5" class="count">{{existingPatient.length}}</el-col>
						<el-col :span="15">patients already existed prior to this import</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-row type="flex" align="middle" justify="space-around" class="grid-content">
						<el-col :span="5" class="count">{{ newPatient.length }}</el-col>
						<el-col :span="15">new patients will be imported</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-row type="flex" align="middle" justify="space-around" class="grid-content count-text">
						<el-col :span="5" class="count">{{ incorrectInvalidPatient.length + invalidProvider.length }}</el-col>
						<el-col :span="15">patients will not be imported - missing emails and / or doctor</el-col>
					</el-row>
				</el-col>
				<el-col :span="3"></el-col>
			</el-row>
		</div>

		<h4 style="font-size:18px">Total events - {{ totalEventCount }}</h4>
		<div style="padding: 11px 39px 39px 0">
			<el-row :gutter="20">
				<el-col :span="7">
					<el-row type="flex" align="middle" justify="space-around" class="grid-content">
						<el-col :span="5" class="count">{{ confirmedEvents + sameSchedulePatient.length }}</el-col>
						<el-col :span="15">events will be scheduled</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-row type="flex" align="middle" justify="space-around" class="grid-content">
						<el-col :span="5" class="count">{{ confirmReschedulePatient.length }}</el-col>
						<el-col :span="15">events will be rescheduled</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-row type="flex" align="middle" justify="space-around" class="grid-content count-text">
						<el-col :span="5" class="count">{{ unconfirmedCount }}</el-col>
						<el-col :span="15">events will not be scheduled / could not be resolved</el-col>
					</el-row>
				</el-col>
				<el-col :span="3"></el-col>
			</el-row>
		</div>

		<el-row type="flex" justify="center">
			<p style="font-size: 18px; font-weight: 500; padding: 65px 0 7px 0">To complete this import, please click the button below</p>
		</el-row>

		<el-row type="flex" justify="center">
			<div class="next">
				<LoadingButton
					type="primary"
					@click="startImport"
					:disabled="complete"
					:loading="loadingButton">
					<b>Complete Import</b>
				</LoadingButton>
			</div>
		</el-row>
	</div>
	<div class="success" v-else>
		<h3 class="success-heading">
			<Lottie :options="defaultOptions" :height="36" :width="36" style="margin-bottom: 21px"/>
			Patients and Events Imported Successfully!
		</h3>		
		<router-link to="/patient">
			<el-button class="allPatient">
				Go to All Patients
			</el-button>
		</router-link>
		<!-- <div v-if="error" class="error-table">
			<h3>Error List</h3>
			<el-table
				:data="error">
				<el-table-column
					prop="name"
					label="Name">
				</el-table-column>
				<el-table-column
					prop="email"
					label="Email">
				</el-table-column>
				<el-table-column
					prop="phone"
					label="Phone">
				</el-table-column>
				<el-table-column
					prop="code"
					label="Error">
				</el-table-column>
			</el-table>
		</div> -->
	</div>
	<div style="background-color: #f8f8f8; padding: 16px" v-if="showErrorBoard">
		<el-row :gutter="20" style="display: flex">
			<el-col v-if="unconfirmedCount > 0">
				<div class="error-content">
					<span class="error-header">Unresolved Events 
						<h4 class="error-count">{{ unconfirmedCount }}</h4>
					</span>
					<el-table
						:data="unconfirmedPatient"
						height="375">
						<el-table-column
							prop="data.name"
							label="Name"
							:min-width="40">
						</el-table-column>
						<el-table-column
							prop="data.email"
							label="Email Address"
							:min-width="60">
						</el-table-column>
					</el-table>
				</div>
			</el-col>	
			<el-col v-if="invalidProvider.length > 0">
				<div class="error-content">
					<span class="error-header">Missing Doctors
						<h4 class="error-count">{{ invalidProvider.length }}</h4>
					</span>
					<el-table
						:data="invalidProvider"
						height="375">
						<el-table-column
							prop="data.name"
							label="Name"
							:min-width="40">
						</el-table-column>
						<el-table-column
							prop="data.email"
							label="Email Address"
							:min-width="60">
						</el-table-column>
					</el-table>
				</div>
			</el-col>
			<el-col v-if="incorrectInvalidPatient.length > 0">
				<div class="error-content">
					<span class="error-header">Not Imported
						<h4 class="error-count">{{ incorrectInvalidPatient.length }}</h4>
					</span>
					<el-table
						:data="invalidPatient"
						height="375">
						<el-table-column
							fixed
							prop="data.name"
							label="Name">
						</el-table-column>
					</el-table>
				</div>
			</el-col>
		</el-row>
	</div>
</div>
</template>

<script>
import Vue from 'vue'
import Lottie from 'vue-lottie'
import { mapActions, mapGetters } from 'vuex'
import sameDay from '@/module/util/same-day'
import ImportTable from '.'
import formatCount from '@/module/util/format-count'
import patientList from '../../table/mixin/patient-list'
import LoadingButton from '@/module/component/LoadingButton'
import LoadSpinnerIcon from '@/module/component/icon/LoadSpinner'
import checkGreenAnimation from '@/module/component/animation/check-green.json'


export default {
	name: 'import-confirm-table',
	extends: ImportTable,

	data() {
		return {
			complete: false,
			showNewPatients: false,
			showScheduledPatients: false,
			showConnectPatient: false,
			showNewUnscheduledPatients: false,
			showRescheduledPatients: false,
			error: null,
			loadingButton: false,
			defaultOptions: { 
				animationData: checkGreenAnimation,
				loop: false
			}
		}
	},

	mounted() {
		this.$emit('totalEventCount', this.totalEventCount)
	},

	methods: {
		...mapActions('provider', [
			'batchCreatePatient'
		]),
		startImport() {
			this.$emit('importing')
			
			const uniqueEventPatients = this.createPatients.map((createPatient) => {
				// Find in current patient list
				const checkPatient = this.patient.find((patient) => patient.data.id === createPatient.id)
				if(checkPatient && checkPatient.future && createPatient.schedule) {
					// Filter schedules which have same event id and same day
					createPatient.schedule = createPatient.schedule.filter((event) => {
						return checkPatient.future.findIndex((futureEvent) => futureEvent.event === event.event && sameDay(futureEvent.time, event.time)) == -1
					})
				}
				return createPatient
			})
			this.loadingButton = true 
			this.batchCreatePatient([...uniqueEventPatients, ...this.createUnscheduledPatients])
			.then((result) => {
				this.complete = true
				this.loadingButton = false
				this.error = (result.error.length > 0) ? result.error.map(({error, data}) => ({...data, ...error})) : null
			})
			.catch((error) => {
				// TODO: show internal error
				this.loadingButton = false
			})
		},
		/**
		 * Update the profile of the `chosenPatient` to the `chosenProfile`
		 *
		 * @param {Object} updateInfo Object containing info about updating profile
		 * @param {String} updateInfo.chosenProfile Profile id to be updated
		 * @param {Number} updateInfo.row Variable matching the event array `row` to be updated
		 * @param {Object} chosenPatient Patient that has to update his profile
		 */
		updateProfile(updateInfo, chosenPatient) {
			const { chosenProfile, row } = updateInfo

			// Finds the index of patient by javascript object equality (checking by reference for same patient)
			const patientIndex = this.patient.findIndex((patient) => patient === chosenPatient)

			// Setting a flag and profile for the patient
			if(chosenProfile) {
				chosenPatient.selectedProfile = true
				chosenPatient.data.event = chosenPatient.data.event.map((event) => {
					if (event.row === row)
						event.profile = [chosenProfile]
					return event
				})
			}
			else {
				chosenPatient.selectedProfile = false
				chosenPatient.data.event = chosenPatient.data.event.map((event) => {
					if (event.row === row)
						event.profile = null
					return event
				})
			}

			// Setting array using `Vue.set()` for reactivity
			Vue.set(this.patient, patientIndex, chosenPatient)
		}
	},

	computed: {
		...mapGetters('provider', [ 'getProvider', 'getProviderProfileList' ]),

		createPatients() {
			return this.importedPatient.map((patient) => {
				if (patient.data) {
					patient.data.email = (patient.data.email || '').trim()
					patient.data.phone = (patient.data.phone || '').trim()
					if (Array.isArray(patient.data.event)) {
						let profile = []
						patient.data.schedule = patient.data.event.map((event) => {
							let eventProfile = this.eventProfileMap[event.id]
							if (eventProfile && ! profile.includes(eventProfile))
								profile.push(eventProfile)
							return {
								event: event.id,
								time: event.time,
								import: true,
								provider: event.provider
							}
						}).filter((event) => {
							// Removing events that have no id
							if(! event.event)
								return false
							//Removing events that are already scheduled for same day
							if(patient.future)
								return patient.future.find((futureEvent) => futureEvent.event === event.event && sameDay(event.time, futureEvent.time)) === undefined
							return true
						})
						// Connect used to connect provider and profile to patients
						patient.data.connect = patient.data.event.map((event) => {
							try {
								// If patient already has the provider connected than skip
								if(patient.data.existingProvider && patient.data.existingProvider.includes(event.provider))
									return null
							} catch (error) {
								console.error('Error removing pre-existing providers ',error)
							}

							if(!event.id && event.profile)
								return {
									profile: event.profile,
									provider: event.provider
								}
							return null
						}).filter((event) => event)
						// { id: event ID, time: new time }
						patient.data.reschedule = patient.data.reschedule ? patient.data.reschedule : []
						patient.data.profile = profile
						delete patient.data.id
						if(patient.data.schedule.length > 0 || patient.data.reschedule.length > 0 || patient.data.connect.length > 0)
							return patient.data
					}
					else if (! patient.invalid || patient.corrected) {
						return patient.data
					}
				}
			}).filter((p) => p != null)
		},

		createUnscheduledPatients() {
			return this.newUnscheduledPatient.filter((patient) => patient.selectedProfile).map((patient) => patient.data)
		},

		eventProfileMap() {
			var map = {}
			this.getProvider.profile.forEach((profile) => {
				if (Array.isArray(profile.event))
					profile.event.forEach((event) => {
						map[event] = profile.id
					})
			})
			return map
		},

		showErrorBoard() {
			return this.complete && !this.loadingButton && ( this.unconfirmedCount > 0 || this.invalidProvider.length > 0 || this.incorrectInvalidPatient.length > 0 )
		},
	},
	
	components: {
		LoadingButton,
		LoadSpinnerIcon,
		Lottie,
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
@import "@/module/app/theme/color.scss";
.grid-content {
	border: solid 1px #e2e2e2;
	height: 100px;
	line-height: 1.3;
}
.count {
	font-size: 50px;
	text-align: center;
}
.count-text {
	color: $danger-color;
}
.error-content {
	box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
	background-color: #ffffff;
	padding: 0 5px;
	.error-header {
		font-size: 16px;
		font-weight: 600;
		color: $danger-color;
		display: flex;
    	align-items: center;
		padding: 12px 10px;
	}
	.error-count {
		border-radius: 10.5px;
		background-color: $danger-color;
		min-width: 29px;
		height: 21px;
		color: #fff;
		font-size: 16px;
		font-weight: 600;
		margin: 0 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 6px;
	}
}
.next {
	display: inline-block;
	.el-button {
		width: 198px;
		height: 36px;
		font-size: 16px;
		font-weight: 600;
		border-radius: 0px;
		color: #fff;
		background-color: #2d3e4f;
		line-height: 0;
	}
	.el-button:hover {
		color: #fff;
		background-color: #202D39;
	}
}
.allPatient {
	margin-bottom: 80px;
	border: none;
	width: 167px;
	height: 36px;
	font-size: 16px;
	font-weight: 600;
	border-radius: 0px;
	line-height: 0;
}
</style>

<style scoped>
.error-content >>> .el-table td {
	border-bottom: none;
	padding: 6px 0;
}
.error-content >>> .el-table__header > th {
	  border-bottom: solid 1px #eeeeee;
}
</style>
